import {useAtom} from "jotai";
import {ModalStateType} from "../components/common/modal/interface";
import {
    initialModalState,
    modal_state_atom1,
    modal_state_atom2,
    modal_state_atom3,
    modal_state_atom4,
    modal_state_atom5,
} from "../components/common/modal/state";

/**
 * 전역 모달 함수
 * @returns
 */
export const useModal = () => {
    const [modalState, setModalState] = useAtom<ModalStateType>(modal_state_atom1);
    const [modalState2, setModalState2] = useAtom<ModalStateType>(modal_state_atom2);
    const [modalState3, setModalState3] = useAtom<ModalStateType>(modal_state_atom3);
    const [modalState4, setModalState4] = useAtom<ModalStateType>(modal_state_atom4);
    const [modalState5, setModalState5] = useAtom<ModalStateType>(modal_state_atom5);

    const resetModal = (depth: number) => {
        switch (depth) {
            case 1:
                setModalState(initialModalState);
                break;
            case 2:
                setModalState2(initialModalState);
                break;
            case 3:
                setModalState3(initialModalState);
                break;
            case 4:
                setModalState4(initialModalState);
                break;
            case 5:
                setModalState5(initialModalState);
                break;
        }
    }

    const handleModal = ({...props}: ModalStateType) => {
        if (props.depth) {
            switch (props.depth) {
                case 1:
                    setModalState({
                        ...props,
                    });
                    break;
                case 2:
                    setModalState2({
                        ...props,
                    });
                    break;
                case 3:
                    setModalState3({
                        ...props,
                    });
                    break;
                case 4:
                    setModalState4({
                        ...props,
                    });
                    break;
                case 5:
                    setModalState5({
                        ...props,
                    });
                    break;
            }
        } else {
            setModalState({
                ...props,
            });
        }
    };

    return {modalState, modalState2, modalState3, modalState4, modalState5, resetModal, handleModal};
};
